import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {Download, starFill} from "../../../assets/images/images";
import {Grid} from "@material-ui/core";

const data = [3, 3, 3, 3, 3]
const useStyles = makeStyles({
  root: {
    // maxWidth: 200,
    margin: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 35,
    paddingLeft: 20,
    paddingRight: 20,
    borderRadius: 4,
    // backgroundColor:'red'
  },
});

export default function ImgMediaCard(props) {
  const classes = useStyles();

  return (
    // <Grid container lg={12} style={{backgroundColor:'red'}}>
    //   <Grid item lg={12} style={{backgroundColor:'orange'}}>
    <Card className={classes.root}>
      <CardActionArea className='display-flex align-items-center flex-column'>
        <div className='display-flex justify-content-center align-items-center'>
          {data.map((i, ind) => <img src={starFill} key={ind} alt='star'/>)}
        </div>
        <Typography variant="body2" color="textSecondary" component="p" className='text-center pt-10 max-width-80 '>
        Arrived as expected, well packed properly protected, looks good construction and finish. Arrived quickly and without any extra fee. 
        </Typography>

      </CardActionArea>
      <div className=' pl-10 display-flex align-items-center align-self-start mt-20'>
        <p className='user-custom-icon'>.</p>
        <div className='pl-20'>
          <p className='m-0 text-bold black-color'>Jason Huang</p>
          <p className='m-0 font-14 in-active-color'>customer</p>
        </div>
      </div>
    </Card>
    // </Grid>
    // </Grid>
  );
}
